export default __webpack_public_path__ + "static/Pala_9-9aaa9046abb5da842498f47eedc50b41.png";